module.exports = __webpack_public_path__ + "static/media/img17_LV.5956c4ea.png";